import {
  RAW_DATA_VIDEO_PLAYER_OPEN_MODAL,
  RAW_DATA_VIDEO_PLAYER_CLOSE_MODAL,
  RAW_DATA_VIDEO_PLAYER_REFRESH_URLS_REQUEST,
  RAW_DATA_VIDEO_PLAYER_REFRESH_URLS_ERROR
} from 'Redux/actionTypes';

export const openVideoPlayerModal = ({ urls, url, title }) => ({
  type: RAW_DATA_VIDEO_PLAYER_OPEN_MODAL,
  payload: { urls: urls || url, title }
});

export const closeVideoPlayerModal = () => ({
  type: RAW_DATA_VIDEO_PLAYER_CLOSE_MODAL,
  payload: {}
});

export const refreshMitacVideoUrlsRequest = ({ fleetId, snapshotId, title }) => ({
  type: RAW_DATA_VIDEO_PLAYER_REFRESH_URLS_REQUEST,
  payload: { fleetId, snapshotId, title }
});

export const refreshMitacVideoUrlsError = () => ({
  type: RAW_DATA_VIDEO_PLAYER_REFRESH_URLS_ERROR,
  payload: {}
});
